import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxSkeletonLoaderComponent } from 'ngx-skeleton-loader';

export type InfoCardVariant = 'icon' | 'plain' | 'progress' | 'editable';

@Component({
  selector: 'app-info-card',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule, NgxSkeletonLoaderComponent],
  templateUrl: './info-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./info-card.component.scss'],
})
export class InfoCardComponent {
  @Input() variant: InfoCardVariant = 'icon';
  @Input() iconName = '';
  @Input() iconColor = '#2563eb';
  @Input() iconWrapperColor = '#eff6ff';
  @Input() title = '';
  @Input() value: string | number = '';
  @Input() valueSuffix = '';
  @Input() progress = 0;
  @Input() progressLabel = '';
  @Input() loading = false;
  @Input() testId = '';

  @Input() editing = false;
  @Input() draft: string | number = '';
  @Input() error: string | null = null;
  @Input() editTooltip = '';
  @Input() min: number | null = null;
  @Input() max: number | null = null;
  @Input() step: number | string = 1;

  @Output() editStart = new EventEmitter<void>();
  @Output() draftChange = new EventEmitter<string>();
  @Output() confirmEdit = new EventEmitter<void>();
  @Output() cancelEdit = new EventEmitter<void>();

  protected readonly valueSkeleton = { width: '56px', height: '20px', borderRadius: '6px', margin: '0' };

  get canEdit(): boolean {
    return this.variant === 'editable' && !this.loading && !this.editing;
  }

  onEnter(): void {
    if (!this.error) this.confirmEdit.emit();
  }

  protected childTestId(suffix: string): string | null {
    return this.testId ? `${this.testId}-${suffix}` : null;
  }
}
